import styled from 'styled-components';
import {FormLabel} from './FormLabel';

export const WordFix = styled(FormLabel)`
    background: var(--form-word-fix-background-color);
    border: 1px solid var(--form-word-fix-border-color);
    color: var(--form-word-fix-text-color);

    flex-shrink: 0;
    padding: 0 var(--horz-input-padding);
    flex-direction: column;
    justify-content: center;
    display: flex;
    margin: 0;
    height: 36px;
    font-weight: 400;
`;
